/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {render} from 'react-dom';
import MapGL, { FlyToInterpolator } from 'react-map-gl';
import {json as requestJson} from 'd3-request';
import * as d3 from 'd3-ease'
import {fromJS} from 'immutable';
import _ from 'lodash';
import DocumentTitle from 'react-document-title';
import WebMercatorViewport from 'viewport-mercator-project';
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase';
import { Loader } from 'semantic-ui-react';
// import ControlPanel from './control-panel';
import {defaultMapStyle, linesLayer } from './map-style.js';
import { MAPBOX_TOKEN } from '../../../config/tokens'
import { createDataSource } from '../../../utils/map';

export default class App extends Component {

  state = {
    mapStyle: '',
    loading: true,
    viewport: {
      latitude: 39.1098747253418,
      longitude: -84.50493621826172,
      zoom: 3,
      bearing: 0,
      pitch: 0,
      // width: 500,
      // height: 500,
      maxZoom: 5.5,
      minZoom: 1,
    },
    features: []
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize);
    this._resize();
    if(this.state.loading && isLoaded(this.props.features))
      this._loadData(this.props.features);
  }

  componentDidUpdate(prevProps) {
    if(this.state.loading && isLoaded(this.props.features))
      this._loadData(this.props.features);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  _resize = () => {
    this.setState({
      viewport: {
        ...this.state.viewport,
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
  };

  // LOAD DATA

  _loadData = features => {
    // create geojson obj
    var linesData = createDataSource(features)

    // add lines to map
    var mapStyle = defaultMapStyle
      .setIn(['sources', 'lines'], fromJS(linesData))
      .set('layers', defaultMapStyle.get('layers').push(linesLayer))

    // data is good to go, create map
    this.setState({mapStyle});

    // Initialize Map
    this._initializeMap();
  };

  _initializeMap = () => {
    // this._onViewportChange({
    //   width: this.props.width || window.innerWidth,
    //   height: this.props.height || window.innerHeight,
    //   zoom: 3,
    // });
    this.setState({loading: false})
  }

  _onViewportChange = viewport => {
    this.setState({
      viewport: {...this.state.viewport, ...viewport},
    });
  }

  _onMapLoad = event => {
    this.map = this.mapRef.getMap()
  }


  render() {
    const {viewport, mapStyle, loading} = this.state;

    if(loading)
      return <Loader active />


    return (
      <DocumentTitle title='bspaint Map'>
      <div style={{overflow: 'hidden'}}>
      <MapGL
        ref={(el) => this.mapRef = el}
        {...viewport}
        mapStyle={mapStyle}
        onViewportChange={this._onViewportChange}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        onLoad={this._onMapLoad}
        >
      </MapGL>

      </div>
      </DocumentTitle>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/Map/Map.js